(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     Reveal al hacer scroll (stagger vía --mt-delay)
     --------------------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var groups = {};
    els.forEach(function (el) {
      var group = el.getAttribute('data-mt-group') || 'default';
      groups[group] = groups[group] || 0;
      var i = groups[group]++;
      el.style.setProperty('--mt-delay', Math.min(i * 0.12, 0.6) + 's');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Carrusel con arrastre (transform), botones y teclado
     --------------------------------------------------------------------- */
  function initCarruseles() {
    document.querySelectorAll('[data-mt-carrusel]').forEach(function (root) {
      var track = root.querySelector('.mt-carrusel-track');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;
      var scope = root.closest('.mt-section') || root.parentElement;
      var prevBtn = scope.querySelector('.mt-carrusel-flecha--prev');
      var nextBtn = scope.querySelector('.mt-carrusel-flecha--next');

      var pos = 0, max = 0, dragging = false, pointerDown = false, startX = 0, startPos = 0, moved = false, activePointerId = null;
      var DRAG_THRESHOLD = 6;

      function metrics() {
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var cardW = cards[0].getBoundingClientRect().width + gap;
        var rootStyle = getComputedStyle(root);
        var padX = (parseFloat(rootStyle.paddingLeft) || 0) + (parseFloat(rootStyle.paddingRight) || 0);
        var visible = root.clientWidth - padX;
        var total = cardW * cards.length - gap;
        max = Math.max(0, total - visible);
        return cardW;
      }

      function setPos(p, animate) {
        pos = Math.min(Math.max(p, -max), 0);
        track.classList.toggle('mt-anim', !!animate);
        track.style.transform = 'translateX(' + pos + 'px)';
      }

      function step(dir) {
        var cardW = metrics();
        setPos(pos - dir * cardW, true);
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerDown = true; dragging = false; moved = false;
        startX = e.clientX; startPos = pos;
        activePointerId = e.pointerId;
        metrics();
      });
      track.addEventListener('pointermove', function (e) {
        if (!pointerDown || e.pointerId !== activePointerId) return;
        var dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          dragging = true;
          moved = true;
          track.classList.add('mt-dragging');
          track.setPointerCapture(activePointerId);
        }
        setPos(startPos + dx, false);
      });
      function endDrag(e) {
        pointerDown = false;
        if (!dragging) return;
        dragging = false;
        track.classList.remove('mt-dragging');
        if (track.hasPointerCapture && activePointerId !== null && track.hasPointerCapture(activePointerId)) {
          track.releasePointerCapture(activePointerId);
        }
        var cardW = metrics();
        var nearest = Math.round(pos / cardW) * cardW;
        setPos(nearest, true);
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
        moved = false;
      }, true);

      window.addEventListener('resize', function () { metrics(); setPos(pos, false); });
      metrics();
    });
  }

  /* ---------------------------------------------------------------------
     Tilt sutil siguiendo el cursor
     --------------------------------------------------------------------- */
  function initTilt() {
    if (reduceMotion || matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.mt-tilt').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(900px) rotateY(0) rotateX(0) translateY(0)';
      });
    });
  }

  /* ---------------------------------------------------------------------
     Parallax suave (transform, no background-attachment)
     --------------------------------------------------------------------- */
  function initParallax() {
    var els = document.querySelectorAll('.mt-parallax');
    if (!els.length || reduceMotion) return;
    var ticking = false;
    function update() {
      ticking = false;
      els.forEach(function (el) {
        var wrap = el.closest('.mt-parallax-wrap') || el.parentElement;
        var r = wrap.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        if (r.bottom < 0 || r.top > vh) return;
        var progress = (r.top) / vh;
        var intensity = parseFloat(el.getAttribute('data-mt-intensity') || '24');
        el.style.transform = 'translateY(' + (progress * intensity) + 'px) scale(1.08)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------------
     Contadores (count-up) al entrar en pantalla
     --------------------------------------------------------------------- */
  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-mt-contador'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var end = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        if (reduceMotion) { el.textContent = end + suffix; return; }
        var start = 0, dur = 1400, t0 = null;
        function frame(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(start + (end - start) * eased) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Galería de producto (imagen principal + miniaturas)
     --------------------------------------------------------------------- */
  function initGaleriaProducto() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (root) {
      var principal = root.querySelector('[data-mt-galeria-principal]');
      var thumbs = root.querySelectorAll('[data-mt-galeria-thumb]');
      if (!principal || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-mt-full');
          if (!full) return;
          principal.style.opacity = '0';
          window.setTimeout(function () {
            principal.src = full;
            principal.style.opacity = '1';
          }, 160);
          thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
          thumb.classList.add('mt-thumb-activa');
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Selector de variantes
     --------------------------------------------------------------------- */
  function initVariantesProducto() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = root.querySelectorAll('[data-mt-opcion]');
      var idInput = root.querySelector('[data-mt-variant-id]');
      var precioEl = root.querySelector('[data-mt-precio]');
      var compareEl = root.querySelector('[data-mt-precio-comparado]');
      var submitBtn = root.querySelector('[data-mt-submit]');
      var submitTexto = root.querySelector('[data-mt-submit-texto]');
      var textos = {
        disponible: root.getAttribute('data-mt-texto-comprar') || 'Añadir al carrito',
        agotado: root.getAttribute('data-mt-texto-agotado') || 'Agotado',
        noDisponible: root.getAttribute('data-mt-texto-no-disponible') || 'No disponible'
      };

      function moneda(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
      }

      function actualizar() {
        if (!selects.length) return;
        var seleccion = Array.from(selects).map(function (s) { return s.value; });
        var match = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!match) {
          if (submitBtn) submitBtn.disabled = true;
          if (submitTexto) submitTexto.textContent = textos.noDisponible;
          return;
        }
        if (idInput) idInput.value = match.id;
        if (precioEl) precioEl.textContent = moneda(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = moneda(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (submitBtn) submitBtn.disabled = !match.available;
        if (submitTexto) submitTexto.textContent = match.available ? textos.disponible : textos.agotado;
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCarruseles();
    initTilt();
    initParallax();
    initContadores();
    initGaleriaProducto();
    initVariantesProducto();
  });
})();
